module.exports = __webpack_public_path__ + "static/media/file rojo small.ea3ba08d.svg";